import React, { Component } from "react";
import { Layout, Page, Card, List, Banner, TextStyle } from "@shopify/polaris";

class Terms extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const primaryAction = {
      content: "Go Pro",
      onAction: () => {
        this.changePage("/pro");
      },
    };
    const secondaryActions = [
      {
        content: "Home",
        onAction: () => {
          this.changePage("/");
        },
      },
      {
        content: "FAQ",
        onAction: () => {
          this.changePage("/faq");
        },
      },
      {
        content: "Privacy Policy",
        onAction: () => {
          this.changePage("/terms");
        },
      },
    ];

    return (
      <Page
        title="Privacy Policy"
        primaryAction={primaryAction}
        secondaryActions={secondaryActions}
      >
        <Banner status="critical">
          <TextStyle variation="strong">
            After much consideration, we have decided to sunset the app on the
            5th of October 2024. This app will cease to function on this date.
            We are currently creating a new app that will replace this one. And
            we will notify you once it is available. We apologize for any
            inconvenience this may cause.
          </TextStyle>
        </Banner>
        <div
          style={{
            paddingTop: 20,
          }}
        ></div>
        <Layout>
          <Layout.Section>
            <Card title="Toast by KiwiSprout - Privacy Policy">
              <Card.Section>
                <p>
                  Toast by KiwiSprout "the App” provides non-intrusive popups
                  "the Service" to merchants who use Shopify to power their
                  stores. This Privacy Policy describes how personal information
                  is collected, used, and shared when you install or use the App
                  in connection with your Shopify-supported store.
                </p>
              </Card.Section>
              <Card.Section title="Personal Information the App Collects">
                <p>
                  When you install the App, we are automatically able to access
                  certain types of information from your Shopify account:
                </p>
                <br />
                <List>
                  <List.Item>
                    The URL of your store, e.g. yourstore.myshopify.com{" "}
                  </List.Item>
                  <List.Item>
                    The active script tags the App has installed on your store,
                    which includes a script we automatically create when you
                    install the App that renders your toast on your storefront.
                  </List.Item>
                  <List.Item>
                    The webhooks we have created on your store, which includes a
                    webhook we automatically create when you install the App
                    that deletes your data from our database when the App is
                    uninstalled.
                  </List.Item>
                </List>
                <br />
                <p>
                  Additionally, we collect the following types of personal
                  information from you and/or your customers once you have
                  installed the App: Information about you and others who may
                  access the App on behalf of your store, such as your name,
                  address, email address, phone number, and billing information;
                  Information about individuals who visit your store, such as
                  their IP address, web browser details, time zone, and
                  information about the cookies installed on the particular
                  device.
                </p>
                <p>
                  We collect personal information directly from the relevant
                  individual, through your Shopify account.
                </p>
              </Card.Section>
              <Card.Section title="How Do We Use Your Personal Information?">
                <p>
                  We use the personal information we collect from you and your
                  customers in order to provide the Service and to operate the
                  App.{" "}
                </p>
              </Card.Section>
              <Card.Section title="Sharing Your Personal Information">
                <p>
                  Finally, we may also share your Personal Information to comply
                  with applicable laws and regulations, to respond to a
                  subpoena, search warrant or other lawful request for
                  information we receive, or to otherwise protect our rights.
                </p>
              </Card.Section>
              <Card.Section title="Your Rights If you are a European resident">
                <p>
                  you have the right to access personal information we hold
                  about you and to ask that your personal information be
                  corrected, updated, or deleted. If you would like to exercise
                  this right, please contact us through the contact information
                  below.
                </p>
                <p>
                  Additionally, if you are a European resident we note that we
                  are processing your information in order to fulfill contracts
                  we might have with you (for example if you make an order
                  through the Site), or otherwise to pursue our legitimate
                  business interests listed above. Additionally, please note
                  that your information will be transferred outside of Europe,
                  including to Canada and the United States.
                </p>
              </Card.Section>
              <Card.Section title="Changes">
                <p>
                  We may update this privacy policy from time to time in order
                  to reflect, for example, changes to our practices or for other
                  operational, legal or regulatory reasons.
                </p>
              </Card.Section>
              <Card.Section title="Contact Us">
                <p>
                  For more information about our privacy practices, if you have
                  questions, or if you would like to make a complaint, please
                  contact us by e-mail at support@kiwisprout.nz
                </p>
              </Card.Section>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  // Change our page, but only if our current page is done loading to prevent memory leaks
  changePage = (url, keepParams = true) => {
    this.props.history.push(url + (keepParams ? window.location.search : ""));
  };

  valueUpdater(field) {
    return (value) => this.setState({ [field]: value });
  }
}

export default Terms;
